import React, { Component } from 'react'
import { Flex } from 'hljd'
import { Button } from 'hljd'
import MoneyItem from '../MoneyItem'
import Store from './store'
import PayModal from './PayModal'
import { observer, inject } from 'mobx-react'
import { getMoney } from '@hlj/hlj-utils'

@inject('pageStore')
@observer
export default class extends Component {
  constructor(props) {
    super(props)

    this.store = new Store()
  }

  render() {
    const { setStoreData } = this.store
    const {
      brokerageInfo: { brokerageBalance, enough }
    } = this.props.pageStore

    return (
      <>
        <Flex
          sp
          vc
          style={{
            flex: 1,
            backgroundColor: '#fff',
            marginRight: 20,
            padding: '30px 30px 30px 20px'
          }}
        >
          <MoneyItem
            title="服务费账户"
            value={getMoney(brokerageBalance)}
            extra={
              !enough && (
                <span style={{ color: '#FF8C30', fontSize: 12 }}>
                  服务费余额不足，请尽快充值以免影响后续推荐
                </span>
              )
            }
          />

          <Button
            type="primary"
            onClick={() => {
              setStoreData({ visible: true })
            }}
          >
            充值
          </Button>
        </Flex>

        <PayModal store={this.store} />
      </>
    )
  }
}
